﻿import * as Res from "./res";
import { createElement, onEvent } from "./_dom";
import { Modal } from "./_modal";
import printJS from "./print-js/js/init";
import { getApiConfig } from "./context";

let printModal;

function addPrintModal() {
	if (!printModal) {
		const printModalContent = createElement("p", { "class": "ui-icon-spinner" }, " ", Res.getString("document.rendering"));
		printModal = new Modal(printModalContent, { class: "v3-docprintprogress v3-dialog", noclose: true }).start();
	}
}

function removePrintModal() {
	if (printModal) {
		printModal.removeModal();
		printModal = null;
	}
}

function printDocument(url) {
	var printUrl = url;
	var n = url.indexOf("?");
	if (n >= 0) {
		n++;
		var qs = new URLSearchParams(url.substring(n));
		qs.set("print", "1");
		printUrl = url.substring(0, n) + qs.toString();
	}
	printJS.init({
		printable: printUrl,
		onLoadingStart: addPrintModal,
		onLoadingEnd: removePrintModal,
		onXHRSetup: function (xhr) {
			const fetchToken = getApiConfig("fetchToken");
			if (fetchToken) {
				xhr.setRequestHeader("X-Fetch-Token", fetchToken);
			}
		},
		onError: function () {
			// will anything happen during the print
			// simply navigate to url
			location.assign(url);
		}
	});
}

function init(context, selector = "a.js-docprint") {
	onEvent(context, selector, "click", (e, el) => {
		const url = el.href;
		e.preventDefault();
		printDocument(url);
	});
}

export { init, printDocument };